import { mediaQueries, palette } from '@centivo/react-components'
import styled from 'styled-components'

import { Content, ContentSection } from 'src/refactor/structure'

export const StyledPractitionerDetails = styled(Content)`
  ${ContentSection} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

  background-color: #f7f4e6;
  min-height: 100%;
  height: fit-content;

  h1 {
    font-size: 2.5rem;
    color: ${palette.brand.darkGreen};
    font-weight: 700;

    > span {
      white-space: nowrap;
    }
  }

  h2 {
    color: ${palette.brand.darkGreen};
    font-weight: 700;
    font-size: 1.875rem;
  }
  h3 + h2 {
    margin: 1.5rem 0;
  }

  h3 {
    font-weight: 600;
    color: ${palette.brand.darkGray};
    font-size: 1.125rem;
  }
  div.title + h3 {
    color: ${palette.brand.gray};
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.875rem;
    font-weight: 400;
    color: ${palette.neutral['grey-icons']};
  }
  p.distance {
    font-size: 0.75rem;
    font-weight: 700;
    color: ${palette.brand.darkGray};
    text-align: right;
    margin: 0 2.5rem 0 0.5rem;
  }

  div.practitioner-attribute {
    p {
      text-transform: capitalize;
      font-weight: 600;
      color: ${palette.brand.gray};
    }
    p:last-of-type {
      margin-bottom: 1rem;
    }

    > h3 {
      color: ${palette.brand.darkGray};
    }
  }

  svg + * {
    margin-left: 0.5rem;
  }

  .back-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin: 1rem 0;
    height: 2rem;
    width: fit-content;
  }

  div.title {
    display: flex;
    flex-direction: row;
    margin: 0;

    svg {
      margin-left: 1rem;
      align-self: center;
    }
  }

  div.map {
    height: 25rem;
    margin-bottom: 2rem;
  }
  div.spacer {
    height: 6.5rem;
  }
  div.location {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-column: span 2;
    padding: 1rem 0;
    border-bottom: 1px solid ${palette.neutral['grey-ebebeb']};
  }
  div.wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border-bottom: 1px solid ${palette.neutral['grey-ebebeb']};
    padding: 1rem 0;

    > p {
      font-size: 1rem;
      vertical-align: middle;
      color: ${palette.brand.gray};
      font-weight: 600;

      svg,
      span {
        line-height: inherit;
        vertical-align: middle;
      }
    }
  }
  div.location > div {
    margin: 0;
    display: flex;
    flex-direction: row;

    &:first-of-type {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      div {
        display: flex;
        flex-direction: column;

        div {
          display: flex;
          flex-direction: row;

          p {
            font-weight: 700;
          }
        }

        span {
          margin-left: 2rem;
          font-weight: 600;
        }
      }
    }

    &:not(:nth-last-of-type(-n + 2)) {
      grid-column: 1 / span 2;
    }

    svg + p {
      font-size: 1rem;
      font-weight: 500;
      color: ${palette.brand.darkGray};
    }

    span {
      color: ${palette.brand.gray};
    }
  }
  div.website-link {
    padding: 1rem 0;

    > button {
      cursor: pointer;
      gap: 10px;
      display: flex;
      align-items: center;
    }

    > a {
      color: ${palette.brand.newPurple};
    }

    font-size: 1rem;
    font-weight: 600;
  }
  div.modal-container {
    div {
      color: #e00085;
    }
  }
`

export const StyledProviderProfilePage = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 1.25rem 1.5rem 1.5rem;

  .back-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin: 1rem 0;
    height: 2rem;
    width: fit-content;

    svg + * {
      margin-left: 0.5rem;
    }
  }

  .mapboxgl-map {
    .icon-centivo--rebrand-active-map-pin {
      height: 1.5rem;
    }
  }

  @media ${mediaQueries.desktop} {
    padding: 0 2.5rem;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${mediaQueries.desktop} {
    width: 50%;

    &:last-of-type {
      padding: calc(1rem + 2rem + 1rem) 0 0 2rem;
    }
  }
`

export const RedirectModal = styled.div`
  padding-bottom: 8px;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  h1 {
    color: ${palette.brand.purple};
    font-size: 1.875rem;
    font-weight: bold;
  }

  img {
    max-width: 50px;
  }

  p {
    padding: 12px 0 32px;
    font-weight: 400;
  }
`
